import React, { useState, useEffect, useContext } from 'react'
import useToastContext from 'hooks/useToastContext'
import { useForm } from 'react-hook-form'
import { apiPost } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Permission from './Permission'
import { useTranslation } from 'react-i18next'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import { useNavigate } from 'react-router-dom'
import AuthContext from 'context/AuthContext'
const { startCase, capitalize } = require('lodash')

const SubAdd = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  })
  const notification = useToastContext()
  const [permissionJons, setPermission] = useState(Permission)
  const { updatePageName } = useContext(AuthContext)

  const onChangeData = event => {
    setPermission(current =>
      current.map(obj => {
        if (obj.manager === event.target.name) {
          if (event.target.id === 'add' && event.target.checked)
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          if (event.target.id === 'edit' && event.target.checked)
            return {
              ...obj,
              [event.target.id]: event.target.checked,
              view: event.target.checked
            }
          else if (event.target.id === 'view' && !event.target.checked) {
            return {
              ...obj,
              add: false,
              edit: false,
              view: false,
              all: false
            }
          }
          return { ...obj, [event.target.id]: event.target.checked }
        }
        return obj
      })
    )
  }

  const onSubmit = async data => {
    const myData = { ...data }
    try {
      const path = apiPath.addSubadmin
      const myObj = {
        manager: 'dashboard',
        add: true,
        edit: true,
        view: true
      }
      const permission = JSON.stringify([myObj, ...permissionJons])
      const sendData = { ...myData, permission }
      const result = await apiPost(path, sendData)
      if (result?.data?.success) {
        navigate('/sub-admin-manager')
        notification.success(result.data.message)
      } else {
        notification.error(result.data.message)
      }
    } catch (error) {
      console.log('error in get all sub admin list==>>>>', error.message)
    }
  }

  useEffect(() => {
    updatePageName(t('ADD_SUB_ADMIN'))
  }, [])

  return (
    <>
      <div className='relative flex-auto p-6'>
        <div className='grid sm:grid-cols-2 lg:grid-cols-4 md:grid-cols-3'>
          <div className='px-2'>
            <OInputField
              name='name'
              wrapperClassName='relative w-full group z-0 mb-6'
              inputLabel={
                <>
                  {t('SUB_ADMIN_NAME')}
                  <span className='text-red-500'>*</span>
                </>
              }
              register={register('name', formValidation['subAdminName'])}
              type='text'
              autoFocus
              errors={errors}
            />
          </div>
          <div className='px-2'>
            <OInputField
              wrapperClassName='relative z-0 mb-6 w-full group'
              inputLabel={
                <>
                  {t('O_EMAIL_ID')}
                  <span className='text-red-500'>*</span>
                </>
              }
              type='email'
              name='email'
              register={register('email', formValidation['email'])}
              errors={errors}
            />
          </div>
        </div>
        <div className='pl-3 pr-3'>
          <div className='overflow-x-auto  overflow-y-auto relative rounded-lg border'>
            <table className='w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 '>
              <thead className='text-xs text-gray-900 border  border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                <tr>
                  <th className='py-3 px-6' scope='col'>
                    {t('SUB_ADMIN_MODULES')}
                  </th>
                  <th scope='col' className='px-6 py-3 '>
                    {t('O_VIEW')}
                  </th>
                  <th scope='col' className='py-3 px-6 '>
                    {t('SUB_ADMIN_ADD')}
                  </th>
                  <th className='py-3 px-6 ' scope='col'>
                    {t('SUB_ADMIN_EDIT')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {permissionJons?.map((item, i) => (
                  <tr
                    key={i}
                    className='bg-white dark:bg-gray-800 dark:border-gray-700 border-b'
                  >
                    <td className='py-4 px-6 border-r '>
                      {capitalize(startCase(item.manager))}
                    </td>
                    <td className='py-4 px-6 border-r '>
                      {item?.shownView && (
                        <input
                          type='checkbox'
                          name={item?.manager}
                          id='view'
                          onChange={onChangeData}
                          checked={item.view}
                        />
                      )}
                    </td>
                    <td className='py-4 px-6 border-r '>
                      {item?.shownAdd && (
                        <input
                          type='checkbox'
                          checked={item.add}
                          onChange={onChangeData}
                          name={item?.manager}
                          id='add'
                        />
                      )}
                    </td>
                    <td className='border-r py-4 px-6'>
                      {item?.shownEdit && (
                        <input
                          type='checkbox'
                          id='edit'
                          name={item?.manager}
                          checked={item.edit}
                          onChange={onChangeData}
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className='p-6 border-t flex items-center justify-center border-solid border-slate-200 rounded-b'>
        <button
          className='text-black bg-[#E1E1E1] outline-none font-normal px-12 py-2.5 text-sm focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
          onClick={() => navigate('/sub-admin-manager')}
          type='button'
        >
          {t('O_BACK')}
        </button>

        <button
          type='submit'
          className='bg-LightBlue text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
          onClick={handleSubmit(onSubmit)}
        >
          {t('O_ADD')}
        </button>
      </div>
    </>
  )
}

export default SubAdd
